import { ImageField, StringField, LinkField } from "../../../types/types";
import {
  VideoPlayerFields,
  VideoPlayerProps,
} from "../../VideoPlayer/types/VideoPlayer.types";

export class VideoPlayerModel {
  private readonly fields?: VideoPlayerFields;
  constructor(props: VideoPlayerProps) {
    this.fields = props.fields;
  }

  get autoPlay(): StringField | undefined {
    return this.fields?.["Auto Play"];
  }

  get title(): StringField | undefined {
    return this.fields?.Title;
  }

  get description(): StringField | undefined {
    return this.fields?.Description;
  }

  get cta(): StringField | undefined {
    return this.fields?.["Play CTA"];
  }

  get splashImage(): ImageField | undefined {
    return this.fields?.["Splash Image"];
  }

  get url(): LinkField | undefined {
    return this.fields?.VidoeUrl;
  }

  get provider(): StringField | undefined {
    return this.fields?.Provider;
  }
}
